import React, { Fragment } from 'react';
import { Row, Col,Table, Badge } from 'reactstrap';


const AddonDetails = ({ data }) => {
    console.log(data,'data product info addons');
    const Addons_Details = data?.plan_has_addons;

        return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                            <thead>
                            <tr>
                                <th>Add On</th>
                                <th>Service Type</th>
                                <th>Sum Assured</th>
                                <th>Deductible</th>
                                <th>Addon Value Type</th>
                                <th>COA</th>
                                <th>COI</th>
                            </tr>
                        </thead>
                        <tbody className="mtd-bg">
                            {Addons_Details?.length > 0 ? (
                                Addons_Details?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.service?.title || '-'}</td>
                                        <td>{item?.add_on_type?.type || '-'}</td>
                                        <td>{item?.sum_assured || '-'}</td>
                                        <td>{item?.deductible || '-'}</td>
                                        <td>{item?.addon_value_type || '-'}</td>
                                        <td>{item?.addon_coa_value || '-'}</td>
                                        <td>{item?.addon_coi_value || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center">No records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default AddonDetails;